<ccl-page-header>
    <div
        class="s-page-header__left c-page-header__left editable-session-header"
    >
        <div class="c-title c-title--secondary text-capitalize" [ngStyle]="fontstyle">
            {{ speakerSessionConfig.labelConfig.label }}
        </div>
        <i class="fa fa-pencil" cclTitle="Edit Label"
        (cclClick)="openConfigDrawer('label', $event, null)"></i>
    </div>
    <div class="s-page-header__right"></div>
</ccl-page-header>
<app-speaker-bio-page></app-speaker-bio-page>
<ccl-content-section>
    <div class="row row--builder">
        <div class="col col-sm-6">
            <h3>Session Template</h3>
        </div>
    </div>
    <div class="row row--builder">
        <div class="col col-sm-6">
            <div class="c-title--subsection">TEMPLATE USED</div>
            <span>{{ templateStyles[speakerSessionConfig.layout] }}</span>
        </div>
        <div class="col col-sm-6">
            <ccl-basic-button
                (clickEvent)="openConfigDrawer('template', $event, null)"
                buttonStyle="c-btn--secondary pull-right"
                >Change to a Different Template
            </ccl-basic-button>
        </div>
    </div>
    <p></p>
    <div class="row row--builder  list-layout">
        <div class="col col-sm-12">
            <div
                [class.c-box]="!hover"
                [class.c-box-nohover]="hover"
                (cclClick)="openConfigDrawer('region', $event, 'body')"
                title="Edit Region"
            >
                <div
                    *ngIf="speakerSessionConfig.layout == 'l_circular'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': speakerSessionConfig.catalogConfig.body.regionConfig.background,
                        margin: speakerSessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: speakerSessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': speakerSessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                title="Edit Session Image"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: speakerSessionConfig.catalogConfig.body.imageConfig.height,
                                            width: speakerSessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: speakerSessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.speakerSessionConfig.layout == 'l_circular'
                                                    ? speakerSessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                        <div
                                            *ngIf="
                                                speakerSessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                'dynamic_img'
                                            "
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></div>

                                        <span
                                            *ngIf="
                                                speakerSessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                'speaker_img'
                                            "
                                            [ngStyle]="{
                                                display: 'inline-block',
                                                'margin-top':
                                                    'calc(' +
                                                    speakerSessionConfig.catalogConfig.body.imageConfig.height +
                                                    ' / 2 - 20px)'
                                            }"
                                            class="fs10"
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(95% - ' + speakerSessionConfig.catalogConfig.body.imageConfig.width + ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.textConfig.background,
                                            color: speakerSessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <div class="clearfix "></div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="speakerSessionConfig.layout == 'l_square'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': speakerSessionConfig.catalogConfig.body.regionConfig.background,
                        margin: speakerSessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: speakerSessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': speakerSessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                title="Edit Session Image"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +speakerSessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: speakerSessionConfig.catalogConfig.body.imageConfig.height,
                                            width: speakerSessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: speakerSessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.speakerSessionConfig.layout == 'l_circular'
                                                    ? speakerSessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                        <div
                                            *ngIf="
                                                speakerSessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                'dynamic_img'
                                            "
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></div>

                                        <span
                                            *ngIf="
                                                speakerSessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                'speaker_img'
                                            "
                                            [ngStyle]="{
                                                display: 'inline-block',
                                                'margin-top':
                                                    'calc(' +
                                                    speakerSessionConfig.catalogConfig.body.imageConfig.height +
                                                    ' / 2 - 20px)'
                                            }"
                                            class="fs10"
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(95% - ' + speakerSessionConfig.catalogConfig.body.imageConfig.width + ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.textConfig.background,
                                            color: speakerSessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="speakerSessionConfig.layout == 'l_noimage'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': speakerSessionConfig.catalogConfig.body.regionConfig.background,
                        margin: speakerSessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: speakerSessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': speakerSessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row mar-right0">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.textConfig.background,
                                            color: speakerSessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="speakerSessionConfig.layout == 'l_banner'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': speakerSessionConfig.catalogConfig.body.regionConfig.background,
                        margin: speakerSessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: speakerSessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': speakerSessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')"
                        title="Edit Session Image">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="banner-img">
                                    <img alt="Banner"
                                        [src]="speakerSessionConfig.catalogConfig.body.imageConfig.banner"
                                        class="w100 img-fluid"
                                        *ngIf="speakerSessionConfig.catalogConfig.body.imageConfig.banner != null"
                                    />
                                    <div
                                        class="text-center aqua-color"
                                        *ngIf="speakerSessionConfig.catalogConfig.body.imageConfig.banner == null"
                                    >
                                        Click to upload static image.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100 banner-sibling"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                speakerSessionConfig.catalogConfig.body.textConfig.background,
                                            color: speakerSessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div class="clearfix "></div>
            </div>
        </div>
    </div>
</ccl-content-section>
